import PaymentProgramView from './payment-program-view';

const MobilePaymentProgramView = () => {
  return <PaymentProgramView isMobile={true} />;
};

export default MobilePaymentProgramView;

